/* HOMEPAGE NOËL — Shanty Biscuits : rails produits + compte à rebours */
(function () {
  'use strict';

  /* Rails produits (flèches) */
  function setupRail(rail) {
    var list = rail.querySelector('[data-x-rail-list]');
    var prev = rail.querySelector('[data-x-rail-nav="-1"]');
    var next = rail.querySelector('[data-x-rail-nav="1"]');
    if (!list) return;
    function update() {
      var max = list.scrollWidth - list.clientWidth - 2;
      /* Tous les produits visibles (tolérance de quelques px pour les arrondis) : pas de flèches */
      var cards = list.children, last = cards[cards.length - 1];
      var fits = !last || last.getBoundingClientRect().right <= list.getBoundingClientRect().right + 8 && list.scrollLeft <= 2;
      rail.classList.toggle('is-static', fits || max <= 6);
      if (prev) prev.disabled = list.scrollLeft <= 2;
      if (next) next.disabled = list.scrollLeft >= max;
    }
    function go(dir) {
      var card = list.querySelector('li');
      var step = card ? card.getBoundingClientRect().width + 24 : list.clientWidth * 0.8;
      list.scrollBy({ left: dir * step, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    list.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    if (window.ResizeObserver) new ResizeObserver(function () { window.requestAnimationFrame(update); }).observe(rail);
    update();
  }
  document.querySelectorAll('[data-x-rail]').forEach(setupRail);

  /* Forme « biscuit Shanty » : vagues régulières + coins arrondis, recalculées à chaque redimensionnement */
  function biscuitPath(W, H) {
    var target = W < 420 ? 44 : 54;            /* largeur visée d'une vague (juste milieu) */
    var d = Math.round(target * 0.26);         /* profondeur d'une vague */
    var n = Math.max(2, Math.round((W - 2 * d) / target));  /* vagues sur la largeur */
    var m = Math.max(2, Math.round((H - 2 * d) / target));  /* vagues sur la hauteur */
    var x0 = d, y0 = d, x1 = W - d, y1 = H - d;
    var sx = (x1 - x0) / n, sy = (y1 - y0) / m;
    var h = d * 4 / 3;                         /* hauteur des points de contrôle → sommet en arc */
    var tx = sx * 0.2, ty = sy * 0.2;          /* décalage horizontal → jonctions en petit « V » comme le biscuit */
    function f(v) { return Math.round(v * 10) / 10; }
    function C(ax, ay, bx, by, ex, ey) { return 'C' + f(ax) + ' ' + f(ay) + ' ' + f(bx) + ' ' + f(by) + ' ' + f(ex) + ' ' + f(ey); }
    var p = ['M' + f(x0 + sx) + ' ' + f(y0)], i, a, b;
    /* Coin : une vague centrée sur la diagonale, aussi ronde que les autres (pas d'« oreille »).
       c1 = 1er point de contrôle (même départ qu'une vague du bord), (mx,my) = sommet du coin,
       (ux,uy) = sens de parcours au sommet, c2 = dernier point de contrôle, (ex,ey) = arrivée. */
    function corner(c1x, c1y, mx, my, ux, uy, c2x, c2y, ex, ey) {
      var k = d * 1.1;
      p.push(C(c1x, c1y, mx - ux * k, my - uy * k, mx, my));
      p.push(C(mx + ux * k, my + uy * k, c2x, c2y, ex, ey));
    }
    var e = d * 0.2;  /* décalage du sommet du coin vers l'extérieur */
    for (i = 1; i < n - 1; i++) { a = x0 + i * sx; b = a + sx; p.push(C(a + tx, y0 - h, b - tx, y0 - h, b, y0)); }   /* haut */
    corner(x1 - sx + tx, y0 - h, x1 + e, y0 - e, 0.7071, 0.7071, x1 + h, y0 + sy - ty, x1, y0 + sy);                                                          /* coin haut-droit */
    for (i = 1; i < m - 1; i++) { a = y0 + i * sy; b = a + sy; p.push(C(x1 + h, a + ty, x1 + h, b - ty, x1, b)); }   /* droite */
    corner(x1 + h, y1 - sy + ty, x1 + e, y1 + e, -0.7071, 0.7071, x1 - sx + tx, y1 + h, x1 - sx, y1);                                                           /* coin bas-droit */
    for (i = n - 1; i > 1; i--) { a = x0 + i * sx; b = a - sx; p.push(C(a - tx, y1 + h, b + tx, y1 + h, b, y1)); }  /* bas */
    corner(x0 + sx - tx, y1 + h, x0 - e, y1 + e, -0.7071, -0.7071, x0 - h, y1 - sy + ty, x0, y1 - sy);                                                          /* coin bas-gauche */
    for (i = m - 1; i > 1; i--) { a = y0 + i * sy; b = a - sy; p.push(C(x0 - h, a - ty, x0 - h, b + ty, x0, b)); }   /* gauche */
    corner(x0 - h, y0 + sy - ty, x0 - e, y0 - e, 0.7071, -0.7071, x0 + sx - tx, y0 - h, x0 + sx, y0);                                                         /* coin haut-gauche */
    return p.join(' ') + 'Z';
  }
  function shape(el) {
    var W = el.offsetWidth, H = el.offsetHeight;
    if (!W || !H) return;
    el.style.clipPath = "path('" + biscuitPath(W, H) + "')";
    el.classList.add('is-shaped');
  }
  var shapes = document.querySelectorAll('.x-scallop');
  if (window.CSS && CSS.supports && CSS.supports('clip-path', "path('M0 0')")) {
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function (entries) { entries.forEach(function (e) { shape(e.target); }); });
      shapes.forEach(function (el) { ro.observe(el); });
    } else {
      shapes.forEach(shape);
      window.addEventListener('resize', function () { shapes.forEach(shape); });
    }
  }

  /* Compte à rebours de la landing (heure de Paris, date fixée dans la section) */
  document.querySelectorAll('[data-x-clock]').forEach(function (clock) {
    var target = new Date(clock.getAttribute('data-target')).getTime();
    if (isNaN(target)) return;
    var els = {
      days: clock.querySelector('[data-x-days]'), hours: clock.querySelector('[data-x-hours]'),
      minutes: clock.querySelector('[data-x-minutes]'), seconds: clock.querySelector('[data-x-seconds]')
    };
    var done = clock.parentNode.querySelector('[data-x-clock-done]');
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function set(el, v) {
      if (!el || el.textContent === v) return;
      el.textContent = v;
      el.classList.remove('is-tick'); void el.offsetWidth; el.classList.add('is-tick');
    }
    var timer;
    function tick() {
      var diff = Math.max(0, target - Date.now());
      if (diff <= 0) {
        clock.hidden = true; if (done) done.hidden = false; clearInterval(timer); return;
      }
      var s = Math.floor(diff / 1000);
      set(els.days, pad(Math.floor(s / 86400)));
      set(els.hours, pad(Math.floor(s % 86400 / 3600)));
      set(els.minutes, pad(Math.floor(s % 3600 / 60)));
      set(els.seconds, pad(s % 60));
    }
    tick();
    timer = setInterval(tick, 1000);
  });

  /* Compte à rebours J-xx avant Noël */
  document.querySelectorAll('[data-x-countdown]').forEach(function (el) {
    var now = new Date();
    var xmas = new Date(now.getFullYear(), 11, 25);
    if (now > new Date(now.getFullYear(), 11, 25, 23, 59)) { el.hidden = true; return; }
    /* Math.round : neutralise le changement d'heure (fin octobre), qui faisait compter 1 jour de trop */
    var days = Math.round((xmas - new Date(now.getFullYear(), now.getMonth(), now.getDate())) / 86400000);
    if (days <= 0) { el.textContent = "C'est Noël ! 🎄"; return; }
    el.querySelector('span').textContent = days;
  });

  /* ---------- Zoom au survol (ordinateur) ---------- */
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (fine) {
    document.querySelectorAll('[data-x-zoom]').forEach(function (media) {
      var img = media.querySelector('img');
      if (!img) return;
      var loaded = false;
      function pos(e) {
        var r = media.getBoundingClientRect();
        media.style.setProperty('--zx', Math.max(0, Math.min(100, (e.clientX - r.left) / r.width * 100)) + '%');
        media.style.setProperty('--zy', Math.max(0, Math.min(100, (e.clientY - r.top) / r.height * 100)) + '%');
      }
      media.addEventListener('mouseenter', function (e) {
        if (!loaded && media.dataset.zoomSrc) { loaded = true; img.removeAttribute('srcset'); img.src = media.dataset.zoomSrc; }
        pos(e); media.classList.add('is-zooming');
      });
      media.addEventListener('mousemove', pos);
      media.addEventListener('mouseleave', function () { media.classList.remove('is-zooming'); });
    });
  }

  /* ---------- Visionneuse plein écran (bouton loupe) ---------- */
  var lb, lbImg, lbThumbs, lbTitle, lbPrice, lbLink, lbCount, lbPrev, lbNext, lbImages = [], lbIndex = 0, lbOpener = null;
  function lbBuild() {
    lb = document.createElement('dialog');
    lb.className = 'x-lightbox';
    lb.setAttribute('aria-label', 'Visuels du produit');
    lb.innerHTML =
      '<div class="x-lightbox__stage">' +
        '<button type="button" class="x-lightbox__close" aria-label="Fermer"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg></button>' +
        '<button type="button" class="x-lightbox__nav x-lightbox__nav--prev" aria-label="Photo précédente"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
        '<img class="x-lightbox__img" alt="">' +
        '<button type="button" class="x-lightbox__nav x-lightbox__nav--next" aria-label="Photo suivante"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '</div>' +
      '<div class="x-lightbox__bar">' +
        '<div class="x-lightbox__thumbs"></div>' +
        '<div class="x-lightbox__info"><div><p class="x-lightbox__title"></p><p class="x-lightbox__price"></p></div>' +
        '<a class="x-btn x-btn--red x-lightbox__link" href="#">Voir le produit</a></div>' +
      '</div>';
    /* dans .x-home pour hériter des couleurs et typos de la DA Noël */
    (document.querySelector('.x-home') || document.body).appendChild(lb);
    lbImg = lb.querySelector('.x-lightbox__img'); lbThumbs = lb.querySelector('.x-lightbox__thumbs');
    lbTitle = lb.querySelector('.x-lightbox__title'); lbPrice = lb.querySelector('.x-lightbox__price');
    lbLink = lb.querySelector('.x-lightbox__link');
    lbPrev = lb.querySelector('.x-lightbox__nav--prev'); lbNext = lb.querySelector('.x-lightbox__nav--next');
    lb.querySelector('.x-lightbox__close').addEventListener('click', lbClose);
    lbPrev.addEventListener('click', function () { lbShow(lbIndex - 1); });
    lbNext.addEventListener('click', function () { lbShow(lbIndex + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) lbClose(); });
    lb.addEventListener('close', function () { document.body.classList.remove('x-lb-open'); if (lbOpener) lbOpener.focus(); });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
      if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
    });
    var sx = null;
    lb.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 50) lbShow(lbIndex + (dx < 0 ? 1 : -1));
    });
  }
  function lbShow(i) {
    if (!lbImages.length) return;
    lbIndex = (i + lbImages.length) % lbImages.length;
    lbImg.src = lbImages[lbIndex];
    lbThumbs.querySelectorAll('button').forEach(function (b, k) { b.setAttribute('aria-current', k === lbIndex ? 'true' : 'false'); });
  }
  function lbClose() { if (lb && lb.open) lb.close(); }
  function lbOpen(btn) {
    if (!lb) lbBuild();
    lbOpener = btn;
    lbImages = (btn.dataset.images || '').split('|').filter(Boolean);
    lbTitle.textContent = btn.dataset.title || '';
    lbPrice.textContent = btn.dataset.price || '';
    lbLink.href = btn.dataset.url || '#';
    lbImg.alt = btn.dataset.title || '';
    lbThumbs.innerHTML = '';
    if (lbImages.length > 1) {
      lbImages.forEach(function (src, k) {
        var b = document.createElement('button');
        b.type = 'button'; b.setAttribute('aria-label', 'Photo ' + (k + 1));
        b.innerHTML = '<img src="' + src.replace(/_1600x\./, '_200x.') + '" alt="">';
        b.addEventListener('click', function () { lbShow(k); });
        lbThumbs.appendChild(b);
      });
    }
    lbPrev.hidden = lbNext.hidden = lbImages.length < 2;
    lbShow(0);
    document.body.classList.add('x-lb-open');
    if (lb.showModal) lb.showModal(); else lb.setAttribute('open', '');
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-x-lightbox]');
    if (!btn) return;
    e.preventDefault();
    lbOpen(btn);
  });
})();
